import {ActionList} from '@primer/react'
import type React from 'react'

import {LABELS} from '../../constants/labels'
import {IssueItem, type IssueItemData} from '../IssueItem'
import {Section} from '../Section'
import styles from './RelationshipsSection.module.css'

export type RelationshipData = {
  parent?: IssueItemData | null
  blockedBy?: IssueItemData[]
  blocking?: IssueItemData[]
}

type RelationshipsSectionProps = {
  sectionHeader: React.ReactElement
  relationships: RelationshipData
  className?: string
}

export const RelationshipsSection = ({sectionHeader, relationships, className}: RelationshipsSectionProps) => {
  const {parent, blockedBy, blocking} = relationships

  const hasBlockedBy = blockedBy && blockedBy.length > 0
  const hasBlocking = blocking && blocking.length > 0
  const hasAnyRelationships = parent || hasBlockedBy || hasBlocking
  const emptyText = hasAnyRelationships ? undefined : LABELS.emptySections.relationships

  return (
    <Section
      id="sidebar-relationships-section"
      sectionHeader={sectionHeader}
      emptyText={emptyText}
      className={className}
    >
      <ActionList variant="full" className={styles.actionListOverrides}>
        {parent && (
          <ActionList.Group>
            <ActionList.GroupHeading as="h4" className={styles.groupHeading}>
              {LABELS.relationNames.parentIssue}
            </ActionList.GroupHeading>
            <IssueItem issue={parent} />
          </ActionList.Group>
        )}
        {hasBlockedBy && (
          <>
            {parent && <ActionList.Divider />}
            <ActionList.Group>
              <ActionList.GroupHeading as="h4" className={styles.groupHeading}>
                {LABELS.relationNames.blockedByIssues}
              </ActionList.GroupHeading>
              {blockedBy.map(issue => (
                <IssueItem key={issue.id} issue={issue} />
              ))}
            </ActionList.Group>
          </>
        )}
        {hasBlocking && (
          <>
            {(parent || hasBlockedBy) && <ActionList.Divider />}
            <ActionList.Group>
              <ActionList.GroupHeading as="h4" className={styles.groupHeading}>
                {LABELS.relationNames.blockingIssues}
              </ActionList.GroupHeading>
              {blocking.map(issue => (
                <IssueItem key={issue.id} issue={issue} />
              ))}
            </ActionList.Group>
          </>
        )}
      </ActionList>
    </Section>
  )
}
